import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 340px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-weight: 600;
  color: #34574A;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const ActionButton = styled.button`
  background: #34574A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #27443a;
  }
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StatusButton = styled.button`
  background: ${props => props.$active ? (props.$activevalue === 1 ? '#22c55e' : '#c62828') : '#eee'};
  color: ${props => props.$active ? '#fff' : '#666'};
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, opacity 0.2s;
  opacity: ${props => props.$active ? 1 : 0.7};
  outline: ${props => props.$active ? '2px solid #34574A' : 'none'};
  box-shadow: ${props => props.$active ? '0 0 0 2px #b7e4c7' : 'none'};
  &:hover {
    opacity: 0.85;
  }
`;

const TipoImovelForm = ({ onSubmit, onCancel, initialData }) => {
  const [nome, setNome] = useState(initialData?.nomeTIPOIMOVEL || '');
  const [ativo, setAtivo] = useState(initialData?.ativoTIPOIMOVEL === 0 ? 0 : 1);

  // Função para gerar slug
  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .toLowerCase();
  }

  // Atualiza slug automaticamente ao digitar nome
  const [slug, setSlug] = useState(initialData?.slugTIPOIMOVEL || '');
  useEffect(() => {
    setSlug(slugify(nome));
  }, [nome]);

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit({ nome, slug, ativo });
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Field>
        <Label>Nome</Label>
        <Input value={nome} onChange={e => setNome(e.target.value)} required />
      </Field>
      <Field>
        <Label>Slug</Label>
        <Input value={slug} readOnly required />
      </Field>
      <Field>
        <Label>Status</Label>
        <StatusRow>
          <StatusButton
            type="button"
            $active={ativo === 1}
            $activevalue={1}
            onClick={() => setAtivo(1)}
          >Ativo</StatusButton>
          <StatusButton
            type="button"
            $active={ativo === 0}
            $activevalue={0}
            onClick={() => setAtivo(0)}
          >Inativo</StatusButton>
        </StatusRow>
      </Field>
      <ButtonRow>
        <ActionButton type="button" style={{background:'#bbb',color:'#222'}} onClick={onCancel}>Cancelar</ActionButton>
        <ActionButton type="submit">Salvar</ActionButton>
      </ButtonRow>
    </FormContainer>
  );
};

export default TipoImovelForm;
